(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-sign-up"] && !Shopify.designMode) return;
  try {
    
  function initMemberSignupForms() {
    document.querySelectorAll('form[id^="MemberSignupForm-"]').forEach((form) => {
      if (form.dataset.memberSignupReady === 'true') return;
      
      form.dataset.memberSignupReady = 'true';

      const country = form.querySelector('[data-address-country]');
      const province = form.querySelector('[data-address-province]');
      const provinceWrap = form.querySelector('[data-address-province-wrap]');
      const noteField = form.querySelector('input[name="customer[note]"]');

      const addProvincePlaceholder = () => {
        if (! province || province.querySelector('option[value=""]')) return;
        
        const option = document.createElement('option');
        option.value = '';
        option.textContent = 'Choose a State';
        province.insertBefore(option, province.firstChild);
        if (! province.getAttribute('data-default')) 
          province.value = '';
        
      };

      const syncProvinceRequired = () => {
        if (! province || ! provinceWrap) return;
        
        const hidden = provinceWrap.style.display === 'none';
        province.required = ! hidden;
        province.toggleAttribute('aria-required', ! hidden);
      };

      if (country && province && window.Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector(country.id, province.id, {hideElement: provinceWrap.id});
        country.addEventListener('change', () => {
          requestAnimationFrame(() => {
            addProvincePlaceholder();
            syncProvinceRequired();
          });
        });
        addProvincePlaceholder();
        syncProvinceRequired();
      }

      form.addEventListener('submit', () => {
        if (! noteField) return;
        
        const valueOf = (selector) => {
          const field = form.querySelector(selector);
          return field
            ? field.value.trim()
            : '';
        };
        const countryText = country && country.selectedOptions[0]
          ? country.selectedOptions[0].textContent.trim()
          : '';
        const provinceText = province && province.selectedOptions[0]
          ? province.selectedOptions[0].textContent.trim()
          : '';
        noteField.value = [
          'Membership sign up',
          'Company: ' + valueOf('[data-member-signup-company]'),
          'Address 1: ' + valueOf('[data-member-signup-address1]'),
          'Address 2: ' + valueOf('[data-member-signup-address2]'),
          'City: ' + valueOf('[data-member-signup-city]'),
          'Province: ' + provinceText,
          'Country: ' + countryText,
          'Zip: ' + valueOf('[data-member-signup-zip]'),
          'Phone: ' + valueOf('input[name="customer[phone]"]')
        ].join('\n');
      });
    });
  }

  function whenMemberSignupReady(attempt) {
    if (window.Shopify && Shopify.CountryProvinceSelector) {
      initMemberSignupForms();
      return;
    }
    if ((attempt || 0) < 20) {
      setTimeout(() => whenMemberSignupReady((attempt || 0) + 1), 50);
    } else {
      initMemberSignupForms();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => whenMemberSignupReady(0));
  } else {
    whenMemberSignupReady(0);
  }

  document.addEventListener('shopify:section:load', initMemberSignupForms);

  } catch(e) { console.error(e); }
})();
})();
